import { Routes, Route, Navigate } from "react-router-dom";
import { Home } from "./pages/Home";
import { ScanPage } from "./pages/ScanPage";
import { ListPage } from "./pages/ListPage";
import { Login } from "./pages/Login";
import { useAuth } from "./contexts/AuthContext";
import { AppLayout } from "./layouts/AppLayout";
// import ApiGatewayTestPage from "./pages/ApiGatewayTestPage";


function DebugAuthBar() {
  const { user, initializing, isLoggedIn } = useAuth();

  return (
    <div
      style={{
        position: "fixed",
        bottom: 12,
        right: 12,
        zIndex: 9999,
        background: "rgba(0,0,0,0.85)",
        color: "#fff",
        padding: "10px 12px",
        borderRadius: 10,
        fontSize: 12,
        lineHeight: 1.4,
        maxWidth: 360,
      }}
    >
      <div><b>Auth Debug</b></div>
      <div>initializing: {String(initializing)}</div>
      <div>isLoggedIn: {String(isLoggedIn)}</div>
      <div>uid: {user?.uid || "-"}</div>
      <div>email: {user?.email || "-"}</div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { isLoggedIn, initializing } = useAuth();
  // 認証状態が確定するまで何もしない
  if (initializing) return null;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  return children;
}

export function App() {
  return (
    <>
      <AppLayout>
        <Routes>
          {/* ログインページ */}
          <Route path="/login" element={<Login />} />

          {/* 各ページはログインされていなければログインページへ */}
          <Route path="/" element={<RequireAuth><Home /></RequireAuth>} />
          <Route path="/scan" element={<RequireAuth><ScanPage /></RequireAuth>} />
          <Route path="/list" element={<RequireAuth><ListPage /></RequireAuth>} />
          {/* <Route path="/test" element={<RequireAuth><ApiGatewayTestPage /></RequireAuth>} /> */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppLayout>
      {/* <DebugAuthBar /> */}
    </>
  );
}